import { useMutation } from 'react-query';

import getGoogleConfig from '@/src/services/getGoogleConfig';

export function useGoogleConfig() {
  return useMutation(getGoogleConfig);
}
